import api from "utils/axios";

export async function getJobs(page = 1, limit = 10, searchTerm = "", sortOption = "newToOld", statusFilter) {
  try {
    console.log("getJobs called with:", { page, limit, searchTerm, sortOption, statusFilter });
    const { data } = await api.get(`${process.env.REACT_APP_BASE_URL}/jobs/get-jobs`, {
      params: { page, limit, search: searchTerm, sort: sortOption, statusFilter },
    });
    if (!data || data.success !== true || !data.data) {
      throw new Error(data.message || "Jobs retrieval failed");
    }
    return {
      jobs: data.data.jobs || [],
      pagination: data.data.pagination || null,
    };
  } catch (error) {
    console.error("getJobs error:", error);
    return { jobs: [], pagination: null };
  }
}

export async function changeJobStatus(jobId, status, rejectionReason = null) {
  try {
    const payload = {
      jobId,
      status,
    };

    if (rejectionReason) {
      payload.rejectionReason = rejectionReason;
    }

    const { data } = await api.post(
      `${process.env.REACT_APP_BASE_URL}/jobs/change-job-status`,
      payload
    );
    if (!data || data.success !== true) {
      throw new Error(data.message || "Failed to change job status");
    }
    return data;
  } catch (error) {
    console.error("changeJobStatus error:", error);
    throw error;
  }
}

export async function deleteJob(jobId) {
  try {
    const { data } = await api.delete(`${process.env.REACT_APP_BASE_URL}/jobs/delete/${jobId}`);
    if (!data || data.success !== true) {
      throw new Error(data.message || "Failed to delete job");
    }
    return data;
  } catch (error) {
    console.error("deleteJob error:", error);
    throw error;
  }
}

export async function updateJob(jobId, jobData) {
  try {
    const { data } = await api.post(
      `${process.env.REACT_APP_BASE_URL}/jobs/update-job`,
      {
        jobId,
        ...jobData,
      }
    );
    if (!data || data.success !== true) {
      throw new Error(data.message || "Failed to update job");
    }
    return data.data;
  } catch (error) {
    console.error("updateJob error:", error);
    throw error;
  }
}

// Dummy method for getting job details by ID
export async function getJobById(jobId) {
  try {
    const { data } = await api.get(`${process.env.REACT_APP_BASE_URL}/jobs/get-job/${jobId}`);
    if (!data || data.success !== true) {
      throw new Error(data.message || "Failed to get job details");
    }
    return data.data;
  } catch (error) {
    console.error("getJobById error:", error);
    throw error;
  }
}

export async function getJobApplications(jobId, page = 1, limit = 1000) {
  try {
    console.log("getJobApplications called with:", { jobId, page, limit });
    const { data } = await api.get(`${process.env.REACT_APP_BASE_URL}/jobs/get-applications`, {
      params: { jobId, page, limit },
    });
    if (!data || data.success !== true) {
      throw new Error(data.message || "Failed to get job details");
    }

    const applicationData = data.data;
    const applications = applicationData.applications || [];

    return {
      applications,
      pagination: {
        total: applications.length,
        page: page,
        limit: limit,
        totalPages: Math.ceil(applications.length / limit)
      }
    };
  } catch (error) {
    console.error("getJobApplications error:", error);
    return { applications: [], pagination: null };
  }
}

// Dummy method for bulk job operations
export async function bulkJobOperation(operation, jobIds) {
  try {
    const { data } = await api.post(`${process.env.REACT_APP_BASE_URL}/jobs/bulk-operation`, {
      operation,
      jobIds,
    });
    if (!data || data.success !== true) {
      throw new Error(data.message || "Failed to perform bulk operation");
    }
    return data;
  } catch (error) {
    console.error("bulkJobOperation error:", error);
    throw error;
  }
}
